// Mock data for the trademark website

export const testimonials = [
  {
    id: 1,
    name: "Rebecca Martinez",
    designation: "CEO & Founder",
    company: "TechFlow Solutions",
    text: "Best decision for our startup! Affordable pricing without compromising quality. Our trademark was approved in record time, and their expertise saved us thousands in potential legal fees.",
    rating: 5
  },
  {
    id: 2,
    name: "Brandon Sullivan",
    designation: "Restaurant Owner",
    company: "Urban Eats Co.",
    text: "Finally, trademark protection that doesn't break the bank. Professional service at a fraction of what competitors charge. My brand is now federally protected and I can expand with confidence.",
    rating: 5
  },
  {
    id: 3,
    name: "Kimberly Washington",
    designation: "Wellness Coach",
    company: "Bloom Wellness",
    text: "Transparent pricing, no hidden fees, and exceptional results. They made trademark registration accessible for my small business. The ROI has been incredible—already blocked two copycats!",
    rating: 5
  },
  {
    id: 4,
    name: "Tyler Henderson",
    designation: "Marketing Director",
    company: "Apex Digital Marketing",
    text: "Cost-effective solution that delivers premium results. Filed trademarks for 5 clients—all approved, zero rejections. Their affordable pricing model is a game-changer for agencies.",
    rating: 5
  },
  {
    id: 5,
    name: "Patricia Lawson",
    designation: "Boutique Owner",
    company: "Luxe Fashion Boutique",
    text: "High-value service at unbeatable prices. Protected my brand name and logo for less than my monthly marketing budget. Every small business owner should prioritize this.",
    rating: 5
  },
  {
    id: 6,
    name: "Michael Chen",
    designation: "Tech Entrepreneur",
    company: "InnovateTech Labs",
    text: "Smart investment with immediate returns. Their comprehensive search prevented costly rebranding. Affordable protection that scales with your business growth.",
    rating: 5
  },
  {
    id: 7,
    name: "Sarah Thompson",
    designation: "Creative Director",
    company: "Artisan Designs Studio",
    text: "Quality doesn't have to be expensive. They proved it. Fast filing, expert guidance, and pricing that respects bootstrapped budgets. Registered 3 trademarks in 6 months!",
    rating: 5
  },
  {
    id: 8,
    name: "James Rodriguez",
    designation: "Business Consultant",
    company: "Strategic Growth Partners",
    text: "I recommend them to every client. Competitive pricing, professional execution, and consistent results. They understand the financial pressures startups face.",
    rating: 5
  },
  {
    id: 9,
    name: "Emily Foster",
    designation: "E-commerce Manager",
    company: "Prime Retail Group",
    text: "Amazon Brand Registry approval in 90 days—at half the cost of other firms. Counterfeit claims dropped 95%. The affordable pricing made protecting our entire product line feasible.",
    rating: 5
  },
  {
    id: 10,
    name: "David Armstrong",
    designation: "Legal Advisor",
    company: "Armstrong & Associates",
    text: "Efficient, affordable, and legally sound. Their streamlined process reduces costs without cutting corners. I trust them with my clients' most valuable assets—their brands.",
    rating: 5
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Instant Consultation & Search",
    description: "Get started immediately with our expedited review process. Comprehensive trademark database search identifies conflicts within 24 hours. No waiting, no uncertainty—just fast, decisive action.",
    icon: "clipboard-check"
  },
  {
    id: 2,
    title: "Same-Day Filing & Submission",
    description: "Your application is prepared, reviewed, and filed with the USPTO within 24-48 hours. Our streamlined process eliminates delays and reduces costs without sacrificing quality or compliance.",
    icon: "file-text"
  },
  {
    id: 3,
    title: "Active Monitoring & Protection",
    description: "Real-time status tracking and proactive office action responses. We don't just file—we fight for your approval. Continuous monitoring ensures your trademark rights are defended until registration is complete.",
    icon: "shield-check"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Basic",
    price: 799,
    popular: false,
    features: [
      "Comprehensive Trademark Search",
      "Single Class Registration",
      "USPTO Filing Included",
      "Basic Office Action Response",
      "Email Support"
    ],
    note: "Essential trademark protection"
  },
  {
    id: 2,
    name: "Professional",
    price: 1499,
    popular: true,
    features: [
      "Everything in Basic",
      "Up to 3 Class Registrations",
      "Priority Filing Service",
      "Advanced Office Action Responses",
      "Trademark Monitoring (1 Year)",
      "Phone & Email Support"
    ],
    note: "Complete trademark solution"
  },
  {
    id: 3,
    name: "Enterprise",
    price: "Custom",
    popular: false,
    features: [
      "Everything in Professional",
      "Unlimited Class Registrations",
      "International Filing Support",
      "Dedicated Account Manager",
      "24/7 Priority Support",
      "Litigation Support"
    ],
    note: "Full-service IP protection"
  },
];

export const services = [
  {
    id: 1,
    title: "Trademark Registration",
    description: "Secure your brand identity with comprehensive trademark protection that safeguards your business name, logo, and intellectual property.",
    icon: "award",
    link: "/services/trademark-registration"
  },
  {
    id: 2,
    title: "Copyright Registration",
    description: "Protect your original creative works including writings, artwork, music, and digital content with official copyright registration.",
    icon: "file-badge",
    link: "/services/copyright-registration"
  },
  {
    id: 3,
    title: "Company Formation",
    description: "Launch your business with confidence through our streamlined company formation services including LLC, Corporation, and DBA registration.",
    icon: "building-2",
    link: "/services/company-formation"
  },
  {
    id: 4,
    title: "Trademark Search",
    description: "Avoid costly conflicts with our thorough trademark search services that identify potential obstacles before you file.",
    icon: "search-check",
    link: "/services/trademark-search"
  },
  {
    id: 5,
    title: "Amazon Brand Registry",
    description: "Enhance your Amazon presence and protect your products from counterfeiters with our Amazon Brand Registry assistance.",
    icon: "shopping-bag",
    link: "/services/amazon-brand-registry"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How quickly can I get trademark protection?",
    answer: "Your application is filed within 24-48 hours, giving you immediate 'pending' status to deter copycats. While USPTO processing takes 8-12 months, you can start using your ™ symbol immediately after filing. Our fast-track service ensures zero delays on our end."
  },
  {
    id: 2,
    question: "Why is your pricing more affordable than competitors?",
    answer: "We've streamlined operations through technology and efficient processes, passing savings directly to you. No expensive office overhead, no unnecessary upsells—just transparent, competitive pricing that makes trademark protection accessible to businesses of all sizes."
  },
  {
    id: 3,
    question: "What if someone is already using my business name?",
    answer: "Act now before they file! Our 24-hour comprehensive search identifies conflicts immediately. If a similar mark exists, we'll strategize alternatives or geographic limitations. First to file wins—don't wait and lose your brand to a competitor."
  },
  {
    id: 4,
    question: "What's included in your pricing? Any hidden fees?",
    answer: "Absolutely no hidden fees. Our transparent pricing includes trademark search, application preparation, filing, and initial monitoring. USPTO government fees ($250-$350 per class) are separate and paid directly to them. What you see is what you pay—guaranteed."
  },
  {
    id: 5,
    question: "What happens if my application gets rejected?",
    answer: "Our 95% approval rate speaks for itself, but if an office action occurs, our Deluxe package includes full response support at no extra charge. We fight for your approval. Lower-tier packages can upgrade for office action assistance—still more affordable than starting over."
  }
];

export const countryCodes = [
  { code: "+1", country: "US/Canada", flag: "🇺🇸" },
  { code: "+44", country: "United Kingdom", flag: "🇬🇧" },
  { code: "+61", country: "Australia", flag: "🇦🇺" },
  { code: "+91", country: "India", flag: "🇮🇳" },
  { code: "+86", country: "China", flag: "🇨🇳" },
  { code: "+49", country: "Germany", flag: "🇩🇪" },
  { code: "+33", country: "France", flag: "🇫🇷" },
  { code: "+81", country: "Japan", flag: "🇯🇵" },
  { code: "+82", country: "South Korea", flag: "🇰🇷" },
  { code: "+39", country: "Italy", flag: "🇮🇹" },
  { code: "+34", country: "Spain", flag: "🇪🇸" },
  { code: "+52", country: "Mexico", flag: "🇲🇽" },
  { code: "+55", country: "Brazil", flag: "🇧🇷" },
  { code: "+27", country: "South Africa", flag: "🇿🇦" },
  { code: "+234", country: "Nigeria", flag: "🇳🇬" },
  { code: "+971", country: "UAE", flag: "🇦🇪" },
  { code: "+65", country: "Singapore", flag: "🇸🇬" },
  { code: "+64", country: "New Zealand", flag: "🇳🇿" },
  { code: "+31", country: "Netherlands", flag: "🇳🇱" },
  { code: "+92", country: "Pakistan", flag: "🇵🇰" },
  { code: "+880", country: "Bangladesh", flag: "🇧🇩" }
];